export default __webpack_public_path__ + "static/vuejs-730b758caefe530442a9a124a67435af.png";